module.exports = __webpack_public_path__ + "media/components/assets/img/pic/safety/cradle-53c4018b777a796934772fdc594739d7.svg";